// TODO: decision - switch to NgCore consts in future roadmap [future release]

// AU legal
export const AGE_MINIMUM = 18;
export const AGE_MAXIMUM = 120;

// dependents
export const AGE_DEPENDENT_MINIMUM = 0;
export const AGE_DEPENDENT_MAXIMUM = 120;
